<template>
  <page>
    <page-title v-t="'p.streamPage.title'" />

    <transition name="fade">
      <button
        v-show="newContentsAvailable"
        class="new-entries button button--outline button--small"
        @click="prependNewContents"
      >
        <font-awesome-icon
          icon="redo"
          size="sm"
        />
        {{ $tc('p.streamPage.label.newEntries', newContentsEntries.length, {count: newContentsEntries.length}) }}
      </button>
    </transition>

    <div class="stream">
      <stream-item
        v-for="(content, index) in contents"
        :key="content.id"
        :content="content"
        :index="index"
        :new-items-count="newContents.count"
      />
    </div>

    <button
      v-show="nextPage"
      :disabled="isLoading"
      class="add-margin-top-double button button--outline button--full button--big"
      @click="loadMore"
    >
      <span>
        <font-awesome-icon
          icon="redo"
          size="sm"
        />
        {{ isLoading ? $t('p.streamPage.label.loadingInProgress') : $t('p.streamPage.label.loadMoreContent') }}
      </span>
    </button>

    <content-modal />
  </page>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import isBlank from 'is-blank'
import validateUrl from 'regex-weburl'
import PageMixin from '@/mixins/pages/Page'
import ContentModal from '@/components/contents/ContentModal'
import StreamItem from '@/components/stream/StreamItem'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'StreamPage',
  mixins: [PageMixin],
  components: {
    ContentModal,
    StreamItem,
    FontAwesomeIcon
  },
  data () {
    // const now = new Date(new Date().setDate(new Date().getDate()-3))
    const now = new Date()

    return {
      initializedAt: now,
      currentPage: 1,
      newContents: {
        fetchInterval: null,
        initializedAt: now,
        response: null,
        count: null
      }
    }
  },
  computed: {
    ...mapState({
      meta: state => state.contents.meta,
      contents: state => state.contents.contents,
      isLoading: state => state.contents.request.isLoading
    }),
    newContentsEntries () {
      return this.newContents.response && !isBlank(this.newContents.response.entries)
        ? this.newContents.response.entries
        : []
    },
    newContentsAvailable () {
      return !isBlank(this.newContentsEntries)
    },
    nextPage () {
      return this.meta && this.meta.nextPage
    }
  },
  watch: {
    newContentsAvailable (value) {
      this.setStreamNewEntries(value)
    },
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        if ($route.query.url !== undefined) {
          const url = validateUrl.test($route.query.url) ? $route.query.url : 'invalid url'
          this.$store.dispatch('contentForm/setSourceUrl', url)
          this.openContentModalLinkMode()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      openContentModalLinkMode: 'openContentModalLinkMode',
      setStreamNewEntries: 'app/setStreamNewEntries',
      setPage: 'contentFilter/setPage',
      setPerPage: 'contentFilter/setPerPage',
      setInitializedAtFrom: 'contentFilter/setInitializedAtFrom',
      setInitializedAtUntil: 'contentFilter/setInitializedAtUntil',
      resetFilter: 'contentFilter/reset',
      fetchContents: 'contents/fetch',
      setContents: 'contents/apply',
      prependContents: 'contents/prepend',
      appendContents: 'contents/append',
      resetContents: 'contents/reset'
    }),
    loadMore () {
      this.currentPage = this.currentPage + 1

      // set filter
      this.setPage(this.currentPage)
      this.setInitializedAtUntil(this.initializedAt)
      this.setInitializedAtFrom('')

      // fetch content
      this.fetchContents()
        .then((response) => {
          this.appendContents(response)
        })
    },
    prependNewContents () {
      this.newContents.initializedAt = new Date()
      this.prependContents(this.newContents.response)
      this.newContents.count = this.newContents.response.entries.length
      this.newContents.response = null
      window.scrollTo(0, 0)
    },
    fetchNewContents () {
      // set filter
      this.setPage('')
      this.setInitializedAtFrom(this.newContents.initializedAt)
      this.setInitializedAtUntil('')

      // fetch new content
      this.fetchContents()
        .then((response) => this.newContents.response = response)
    },
  },
  created () {
    this.setStreamNewEntries(false)

    // setup filter
    this.resetFilter()
    this.setPage(1)
    this.setInitializedAtUntil(this.initializedAt)

    // fetch content
    this.fetchContents()
      .then((response) => {
        this.setContents(response)
        this.$emit('loadingDone')
      })

    this.newContents.fetchInterval = setInterval(() => {
      this.fetchNewContents()
    }, 30000)
  },
  beforeDestroy () {
    this.resetFilter()
    this.resetContents()
    clearInterval(this.newContents.fetchInterval)
  }
}
</script>

<style lang="sass" scoped>
.stream
  margin-top: 85px;

.new-entries
  position: absolute;
  left: 50%;
  top: 60px;
  transform: translateX(-50%)

.fade-enter-active
  animation: coming 300ms
  animation-delay: 200ms
  opacity: 0

.fade-leave-active
  animation: going 200ms

@keyframes coming
  from
    opacity: 0
  to
    opacity: 1

@keyframes going
  from
    opacity: 1
  to
    opacity: 0
</style>



// WEBPACK FOOTER //
// src/pages/stream/StreamPage.vue